export const localRoutes = {
  home: "/*",
  homeSpecify: "/",
  findAvailableChannel: "/findAvailableChannel",
  videoCall: "/videoCall",
  supportMyProfile: "/supportMyProfile",
  getChannel: "/getChannel",
  notAvailableTime: "/notAvailableTime",
  notFoundChannel: "/notFoundChannel",
  verification: "/verification",
  login: "/login",
  register: "/register",
  accountSetup: "/setup/*",
  accountSetupSpecify: "/setup",
  blockedPermission: "/permission",
  accountSetupPages: {
    basic: "/setup/basic-details",
    gender: "/setup/gender",
    state: "/setup/state",
    education: "/setup/education",
    email: "/setup/email",
    avatar: "/setup/avatar",
    bio: "/setup/bio",
    interests: "/setup/interests",
  },
  betaFlow: {
    welcome: "/welcome",
    finish: "/finish",
    success: "/success",
    invite: "/invite-friends",
    steps: {
      specify: "/details/*",
      base: "/details",
      email: "/details/email",
      avatar: "/details/avatar",
      bio: "/details/bio",
      interests: "/details/interests",
    },
  },

  onboarding: "/onboarding/*",
  onboardingSettings: "/onboarding/settings",
  onboardingWelcome: "/onboarding/welcome",
  onboardingPermissions: "/onboarding/permissions",
  onboardingSpecify: "/onboarding",
  onboardingPages: {
    firstStep: "/onboarding/first-step",
    secondStep: "/onboarding/second-step",
    thirdStep: "/onboarding/third-step",
    forthStep: "/onboarding/forth-step",
  },
  invite: "/invite/*",
  inviteSpecify: "/invite/",
};
